import {
  all, takeLatest, put, call,
} from 'redux-saga/effects'
import * as ab18n from 'ab18n'
import jwtDecode from 'jwt-decode'
import locales from 'i18n/locale'

import errorsFormat from 'shared/errors-format'
import history from 'shared/history'
import api from 'services/api'
import storage from 'services/storage'
import { actions, types } from './actions'

const { t } = ab18n

const language = localStorage.getItem('language') === 'pt-BR' || localStorage.getItem('language') === 'es' ? localStorage.getItem('language') : 'pt-BR'

function getCurrency(jwt) {
  const data = jwtDecode(jwt)
  const currency = (data.storeCurrency) || 'BRL'
  const newLocale = Object.entries(locales).reduce((acc, items) => ({
    ...acc,
    [items[0]]: { ...items[1], currency }
  }), {})
  ab18n.config(newLocale)
  ab18n.set(language)
}

function* loginSaga({ payload: { idToken } }) {
  try {
    const { jwt } = yield call(api.post, '/login/google', { idToken })
    yield storage.save('jwt', jwt)
    getCurrency(jwt)
    yield put(actions.setStatus({
      data: jwtDecode(jwt)
    }))
    yield put(actions.goHome())
  } catch (error) {
    console.error('[LOGIN]', error)
    yield put(actions.setStatus({
      status: {
        error: t('auth.connectionFail'),
        disabled: false,
      },
    }))
  }
}

function* goHome() {
  const path = yield storage.fetch('restoreUrl')

  yield storage.remove('restoreUrl')
  yield history.push(path || '/')
}

function* logoutSaga() {
  yield storage.remove('jwt')
  yield history.push('/login')
}

function* refreshTokenSaga() {
  yield put(actions.setStatus({
    status: {
      loading: true,
      disabled: false,
      error: null,
    },
  }))
  try {
    const { jwt } = yield call(api.get, '/refresh-token')
    yield storage.save('jwt', jwt)
    getCurrency(jwt)
    yield put(actions.setStatus({
      data: jwtDecode(jwt)
    }))
  } catch (error) {
    console.error(error)
    errorsFormat(error, t('general.notification.error'))
  } finally {
    yield put(actions.setStatus({
      status: {
        loading: false,
        disabled: false,
        error: null,
      },
    }))
  }
}

export default function* () {
  yield all([
    takeLatest(types.LOGIN, loginSaga),
    takeLatest(types.GO_HOME, goHome),
    takeLatest(types.LOGOUT, logoutSaga),
    takeLatest(types.REFRESH_TOKEN, refreshTokenSaga),
  ])
}
